export default __webpack_public_path__ + "static/003-ecdbba741102090dd30495148dcd1f25.png";